const TableHead = ({ children, width="" }) => {
    return  (
        <th className="main-list__table-head-cell" style={{width:width}}>
            {children}
        </th>
    );
};

export default TableHead;
